import type { IConsumable } from '@experiences/interfaces';

interface ConsumableBundleRange {
    bundleStartDate?: number;
    bundleEndDate?: number;
}

// Earliest pool start to latest pool end. An inverted range (only a late start on one pool plus
// only an early end on another) is reported as no range at all rather than left for callers to guard.
export const getConsumableBundleRange = (consumable: IConsumable): ConsumableBundleRange => {
    const startDates = consumable.pools.map(pool => pool.startDate).filter((d): d is number => d != null);
    const endDates = consumable.pools.map(pool => pool.endDate).filter((d): d is number => d != null);
    const bundleStartDate = startDates.length ? Math.min(...startDates) : undefined;
    const bundleEndDate = endDates.length ? Math.max(...endDates) : undefined;
    if (bundleStartDate != null && bundleEndDate != null && bundleStartDate > bundleEndDate) {
        return {};
    }
    return {
        bundleStartDate,
        bundleEndDate,
    };
};
